//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server, POAUrl } from "../services/constants";

export default {
  async mounted() {
    await this.loadCompany();

    this.$hideLoader();
    this.$store.state.navMenu = false;
    this.$store.state.isLogged = false;
    const userId = localStorage.getItem(server.USER_ID);

    // console.log("Login mounted : " + api.isLoggedIn());
    // console.log("Login mounted : " + userId);
    if (userId && api.isLoggedIn()) {
      this.$router.push("/");
    }
  },
  // ⭐ ใหม่ — เคลียร์ timer กันหน่วยความจำรั่วถ้าออกจากหน้านี้ระหว่างที่ dialog OTP เปิดอยู่
  beforeDestroy() {
    this.stopOtpCountdown();
  },
  components: {
    SuccessDialog,
  },
  data() {
    return {
      isShowPassword: false,
      account: {
        company_code: "",
        username: "",
        password: "",
        keep_me_logged_in: false,
        remember_device: true, // ⭐ ใหม่ — ค่าเริ่มต้นติ๊กไว้ เหมือนใน mockup
      },
      fullPage: true,
      dialog: false,
      companyAll: [],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",

      // ⭐ ใหม่ — state สำหรับ OTP dialog (SMS)
      otpDialog: false,
      otpCode: "",
      phoneMasked: "",
      otpCompanyCode: "",
      otpUsername: "",
      otpToken: "",
      otpRefCode: "",
      otpUserId: null,

      // ⭐ ใหม่ — นับถอยหลัง 5 นาที (300 วินาที) เหมือนหน้า forgot password
      otpCountdown: 300,
      otpCountdownTimer: null,
      otpExpired: false,
    };
  },

  computed: {
    // ⭐ ใหม่ — แปลงวินาทีที่เหลือเป็น mm:ss
    otpCountdownDisplay() {
      const m = Math.floor(this.otpCountdown / 60)
        .toString()
        .padStart(2, "0");
      const s = (this.otpCountdown % 60).toString().padStart(2, "0");
      return `${m}:${s}`;
    },
  },

  methods: {
    async previewnoticefilepdf(file_name) {
      let pdf_newTab = window.open(`${POAUrl}/file_login/DTime_Poster.pdf`);

      return;
    },
    async previewprivacypolicyfilepdf(file_name) {
      // let pdf_newTab = window.open(
      //       `${POAUrl}/file_login/DCM_Privacy_Policy_(ENG).pdf`
      //   );
      window.open(`http://${window.location.host}/privacy-policy`);

      return;
    },
    goWeb() {
      this.dialog = false;
      this.$router.push("/dashboard");
    },
    changeCompany(val) {
      // console.log("changeCompany:", val);
      localStorage.setItem(server.COMPANYID, val);
    },
    async loadCompany() {
      var result = await api.getAllCompany();
      this.companyAll = result.data;
    },

    // ⭐ ใหม่ — เริ่ม/รีเซ็ตนับถอยหลัง 5 นาที (เรียกตอนเปิด dialog OTP ครั้งแรก และตอนกด Resend code)
    startOtpCountdown() {
      this.stopOtpCountdown();
      this.otpCountdown = 300; // 5 นาที เหมือน forgot password
      this.otpExpired = false;
      this.otpCountdownTimer = setInterval(() => {
        if (this.otpCountdown > 0) {
          this.otpCountdown--;
        } else {
          this.stopOtpCountdown();
          this.otpExpired = true;
        }
      }, 1000);
    },
    // ⭐ ใหม่ — หยุด timer (ตอนปิด dialog / verify สำเร็จ / ออกจากหน้า)
    stopOtpCountdown() {
      if (this.otpCountdownTimer) {
        clearInterval(this.otpCountdownTimer);
        this.otpCountdownTimer = null;
      }
    },

    submit() {
      if (
        !this.account?.company_code?.trim() ||
        !this.account?.username?.trim() ||
        !this.account?.password?.trim()
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Login Fail",
          "Incorrect Company Code or Username or Password",
          "text-h5 red--text text-center",
        );
        return;
      }
      this.$showLoader();

      this.$store
        .dispatch({
          type: "doLogin",
          company_code: this.account.company_code,
          username: this.account.username,
          password: this.account.password,
        })
        .then((val) => {
          this.$hideLoader();

          // ⭐ ใหม่ — backend บอกว่าต้องยืนยัน OTP (SMS) ก่อน
          if (val && val.require_otp) {
            this.otpUserId = val.user_id;
            this.otpCompanyCode = val.company_code;
            this.otpUsername = val.username || this.account.username;
            this.otpToken = val.otp_token;
            this.otpRefCode = val.ref_code;
            this.phoneMasked = val.phone_masked;
            this.otpCode = "";
            this.otpDialog = true;
            this.startOtpCountdown(); // ⭐ ใหม่ — เริ่มนับถอยหลัง 5 นาทีทันทีที่เปิด dialog
            return;
          }

          if (this.$store.getters["isLogin"]) {
            if (localStorage.getItem(server.ROLE) == "ADMIN") {
              this.dialog = true;
            } else {
              this.$router.push("/dashboard");
            }
          }
        })
        .catch((error) => {
          this.$hideLoader();

          if (
            error.response &&
            error.response.data &&
            error.response.data.success === false
          ) {
            // แกะเอาข้อความ "ชื่อผู้ใช้งาน หรือรหัสผ่านไม่ถูกต้อง" ที่หลังบ้านส่งมาแสดง
            const alertMessage =
              error.response.data.message ||
              "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง";

            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "เข้าสู่ระบบไม่สำเร็จ",
              alertMessage,
              "text-h5 red--text text-center",
            );
            return;
          } else if (error.response) {
            if (error.response.status === 503 && error.response.data.ip_error) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "ไม่สามารถเข้าใช้งานได้",
                error.response.data.ip_error,
                "text-h5 red--text text-center",
              );
              return;
            } else {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "เกิดข้อผิดพลาดจากระบบ",
                "เซิร์ฟเวอร์ขัดข้องชั่วคราว กรุณาติดต่อผู้ดูแลระบบ",
                "text-h5 red--text text-center",
              );
              return;
            }
          }

          // 💡 3. เคสเน็ตหลุด ยิงไปหาหลังบ้านไม่ได้เลย
          else {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "การเชื่อมต่อล้มเหลว",
              "ไม่สามารถเชื่อมต่อเครือข่ายได้ กรุณาตรวจสอบอินเทอร์เน็ตของคุณ",
              "text-h5 orange--text text-center",
            );
            return;
          }
        });
    },

    // ⭐ ใหม่ — ยืนยัน OTP (SMS) ขั้นตอนที่ 2 ของ login
    async submitOtp() {
      this.$showLoader();
      try {
        const ok = await this.$store.dispatch({
          type: "completeLoginAfterOtp",
          company_code: this.otpCompanyCode,
          username: this.otpUsername,
          otp_token: this.otpToken,
          ref_code: this.otpRefCode,
          otp_code: this.otpCode,
          remember_device: this.account.remember_device,
        });
        this.$hideLoader();

        if (ok) {
          this.stopOtpCountdown(); // ⭐ ใหม่ — verify ผ่านแล้วเลิกนับถอยหลัง
          this.otpDialog = false;
          if (localStorage.getItem(server.ROLE) == "ADMIN") {
            this.dialog = true;
          } else {
            this.$router.push("/dashboard");
          }
        }
      } catch (error) {
        this.$hideLoader();
        const alertMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่";
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ยืนยัน OTP ไม่สำเร็จ",
          alertMessage,
          "text-h5 red--text text-center",
        );
      }
    },

    // ⭐ ใหม่ — กด "Resend code"
    async resendOtp() {
      try {
        const res = await api.resendLoginOtp({ user_id: this.otpUserId });
        this.otpCode = "";
        this.otpToken = res.otp_token;
        this.otpRefCode = res.ref_code;
        this.startOtpCountdown(); // ⭐ ใหม่ — ส่งรหัสใหม่แล้ว รีเซ็ตนับถอยหลังเป็น 5 นาทีใหม่
      } catch (error) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ส่งรหัสไม่สำเร็จ",
          "กรุณาลองใหม่อีกครั้ง",
          "text-h5 red--text text-center",
        );
      }
    },

    // ⭐ ใหม่ — ปิด dialog OTP
    cancelOtp() {
      this.stopOtpCountdown(); // ⭐ ใหม่
      this.otpDialog = false;
      this.otpCode = "";
    },

    forgotPassword() {
      // alert("Forgot Password");
      this.$router.push("/forgot-password");
    },
    onCancel() {
      // console.log("User cancelled the loader.");
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
